import { getConfig } from '@chegg-web-tools/config-plugin';
import { OneAuthProps } from '@chegg/one-auth';
import { getRioConfig } from '@lib/rio';

export const initialProps = {
  env: getConfig('env'),
  view: 'signin',
  country: '',
  options: {
    legacyMfa: true,
    signin: {
      ssoProviders: ['apple', 'facebook', 'google'], // 'openPass'
    },
    signup: {
      form: {
        credentials: {
          ssoProviders: ['apple', 'facebook', 'google'], // 'openPass'
        },
        userInfo: {
          student: {
            highschool: {
              highschoolGradYearSelect: true,
            },
            college: {
              collegeSelect: {
                yearInSchool: true,
              },
            },
          },
          parent: {},
        },
      },
      // if this is true, onboarding questions will show in the signup flow
      // showOnboardingQuestions: true
    },
    resetPassword: {
      customerServiceUrl: {
        newWindow: true,
      },
    },
  },
  rioConfig: getRioConfig(),
} as OneAuthProps;
